<template>
  <div class="bg-white rounded-md shadow-md p-5">
    <slot />
  </div>
</template>

<script>
export default {};
</script>
